<template>
  <svg width="34" height="45" viewBox="0 0 34 45" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0h1.535a7 7 0 0 1 4.188 1.39l20.763 15.5a7 7 0 0 1 0 11.22L5.723 43.61A7 7 0 0 1 1.535 45H0V0Z"
      :fill="color"
      stroke="none"
      stroke-width="1"
      fill-rule="evenodd"
    />
  </svg>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class LabelIcon extends Vue {
  @Prop({ type: String, default: '#806AE8' }) color: string;
}
</script>
